// extracted by mini-css-extract-plugin
export default {"yellowbackground":"jobs_yellowbackground__No+nx","boldfont":"jobs_boldfont__Qrzsg","deletebutton":"jobs_deletebutton__fIYw6"};